<template>
  <component
    v-if="dynamicBlock"
    class="dynamic"
    :is="dynamicBlock.type"
    :blockReference="block"
    :block="dynamicBlock"
    :blocks="blocks"
    :definitions="definitions"
    :asset="asset"
    v-on:destroy="destroy"
    :showActions="shouldShowActions"
    :deletable="deletable"
    :editing="editing"
    :save-trigger="saveTrigger"
    dynamic
  />
</template>

<script>
import contractComponents from '@/Mixins/contractComponents';

export default {
  mixins: [contractComponents],

  props: {
    deletable: {
      type: Boolean,
      default: false,
    },
    block: Object,
    blocks: Array,
    showActions: {
      type: Boolean,
      default: true,
    },
    forceHideActions: {
      type: Boolean,
      default: false,
    },
    definitions: {
      type: Array,
      default: () => [],
    },
    asset: Object,
    editing: {
      type: Boolean,
      default: false,
    },
    saveTrigger: {
      type: String,
      default: null,
    },
  },

  computed: {

    state() {
      return this.$store.state.assetState;
    },

    dynamicBlock() {

      const block = this.blocks.find(
        (b) => b.contract_reference === this.block.reference,
      );

      if (!block) {
        console.log(this.block);
        throw new Error("Can't find Dynamic Block for reference: ", this.block.reference);
      }

      return block;
    },

    shouldShowActions() {
      if (this.state.state === 'executed') {
        return false;
      }

      if (this.forceHideActions) {
        return false;
      }

      if (
        this.dynamicBlock.settings
        // eslint-disable-next-line no-prototype-builtins
        && this.dynamicBlock.settings.hasOwnProperty('editable')
      ) {
        return this.dynamicBlock.settings.editable;
      }

      return this.showActions;
    },
  },

  methods: {
    destroy(reference) {
      this.$emit('destroy', reference);
    },
  },
};
</script>
